/** @format */

import { forwardRef, useImperativeHandle } from "react";
import Schema, { FormViewProps } from "./schema";
import _ from "lodash";
import { Button } from "semantic-ui-react";

function SchemaArray(
  { controls, showError, value, onChange, configAuction }: FormViewProps,
  ref: any
) {
  useImperativeHandle(ref, () => ({
    validate: validate,
  }));
  function validate(input: any) {
    return true;
  }
  function handleChange(index: number, val: any) {
    let tmp = _.cloneDeep(value);
    tmp[index] = val;
    onChange(tmp);
  }
  function add() {
    let tmp = _.cloneDeep(value);
    tmp.push({});
    onChange(tmp);
  }
  function remove(index: number) {
    let tmp = _.cloneDeep(value);
    tmp.splice(index, 1);
    onChange(tmp);
  }
  return (
    <div>
      {value && value.length > 0 ? (
        <div>
          {value.map((v: any, index: number) => (
            // <p>{JSON.stringify(v)}</p>
            <div className="border rounded-md p-2 mt-2 flex gap-2">
              <Schema
                value={v}
                showError={showError}
                controls={controls}
                // ref={ref}
                onChange={(val: any) => {
                  handleChange(index, val);
                }}
              />
              <div className="w-32">
                <Button
                  content="Remove"
                  icon="close"
                  color="red"
                  onClick={() => {
                    remove(index);
                  }}
                />
              </div>
            </div>
          ))}

          {/* <p>Has data</p> */}
        </div>
      ) : (
        <div>
          <p>Empty data</p>
        </div>
      )}
      <div className="mt-2">
        <Button
          content="Add"
          icon="plus"
          color="blue"
          onClick={() => {
            add();
          }}
        />
      </div>
    </div>
  );
}
export default forwardRef(SchemaArray);
